import React from 'react'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'sb-hooks'


const ZinaImage = ({ children }) => {
  const ref = useRef(null)

  useEffect(() => {
    const node = ref.current

    if (node && window.zina) {
      window.zina.addItem(node)

      return () => {
        window.zina.removeItem(node)
      }
    }
  }, [ ref ])

  return React.cloneElement(children, {
    // [window.zina.opts.srcAttr]: children.props.src, TODO how to get "srcAttr" from Zina instance initialized in SSR inline script?
    'data-zina-height-src': children.props.src,
    src: null,
    ref,
  })
}

ZinaImage.propTypes = {
  children: PropTypes.node.isRequired,
}


export default ZinaImage
